import '@fortawesome/react-fontawesome';


export default function HidePasswordIcon({ showPassword, setShowPassword }) {


//afficher ou masquer le mot de passe
const handleShowPassword = () => {
    setShowPassword(!showPassword);
}


    return (
        <button 
            onClick={handleShowPassword} 
            id='HideShowPassword' 
            type='button'
            className="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition-colors duration-200"
        >
            {showPassword === false ? (
                <i className="fa-regular fa-eye text-lg"></i>
            ) : (
                <i className="fa-regular fa-eye-slash text-lg"></i>
            )}
        </button>
    )
}